"use client";

import { motion } from "framer-motion";

type SectionEyebrowProps = {
  label: string;
  align?: "centered" | "left";
  className?: string;
};

export default function SectionEyebrow({
  label,
  align = "centered",
  className,
}: SectionEyebrowProps) {
  return (
    <motion.div
      className={`flex items-center gap-3 whitespace-nowrap mb-6 ${
        align === "centered" ? "justify-center" : "justify-start"
      } ${className ?? ""}`}
      initial={{ opacity: 0, y: 8 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4 }}
    >
      <p className="font-accent text-[clamp(0.8125rem,0.75rem+0.25vw,0.9375rem)] font-medium tracking-[0.18em] text-eyebrow uppercase">
        {label}
      </p>
    </motion.div>
  );
}
